// src/hooks/useUserFeedback.js
//
// Hook que agrega o feedback recebido por um usuário (Fase B.4).
// Lê a coleção `userFeedback` (campos: evaluator, evaluated, rating, text,
// contextOfferId, createdAt) e devolve média e contagem.
import { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';

const useUserFeedback = (userId) => {
  const [data, setData] = useState({
    loading: true,
    average: 0,
    count: 0,
    feedbacks: [],
  });

  useEffect(() => {
    let cancelled = false;
    if (!userId) {
      setData({ loading: false, average: 0, count: 0, feedbacks: [] });
      return undefined;
    }

    const fetchFeedback = async () => {
      try {
        const q = query(
          collection(db, 'userFeedback'),
          where('evaluated', '==', userId)
        );
        const snap = await getDocs(q);
        const feedbacks = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        const count = feedbacks.length;
        const sum = feedbacks.reduce((acc, f) => acc + (Number(f.rating) || 0), 0);
        const average = count > 0 ? sum / count : 0;

        if (!cancelled) {
          setData({ loading: false, average, count, feedbacks });
        }
      } catch (err) {
        console.error('Erro ao buscar feedbacks do usuário:', err);
        if (!cancelled) {
          setData({ loading: false, average: 0, count: 0, feedbacks: [] });
        }
      }
    };

    fetchFeedback();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return data;
};

export default useUserFeedback;
